import type { BundleInfo } from '../types/BundleInfo.js';

/**
 * Get a record of the consumed dependencies and their import paths by the given bundle info.
 * @param info - The bundle info.
 * @returns The record of consumed dependencies and their import paths.
 */
export function getConsumedPaths(info: BundleInfo): Record<string, Set<string>> {
  const consumedPaths: Record<string, Set<string>> = {};
  // Iterate through imports and find their path from the resolve map.
  for (const entryInfo of Object.values(info)) {
    if (!entryInfo) {
      continue; // This is to make type-checking happy
    }
    // iterate through all package names of result.info.consumes
    for (const consume of entryInfo.consumes) {
      consumedPaths[consume.packageName] ??= new Set();
      consumedPaths[consume.packageName].add(consume.importPath);
    }
  }

  return consumedPaths;
}
